import {
  ISchoolTicketBaseProps,
  ISchoolTicketCreateParams,
  ISchoolTicketCreateProps,
  ISchoolTicketProps,
  ISchoolTicketSimpleProps,
  ISchoolTicketUpdateParams,
} from './types';
import { api } from '../DefaultService';
import { ISchoolShiftCreateParams } from '../SchoolShift/types';

const ENDPOINT = 'v1/schoolticket';

export const createSchoolTicketAsync = async ({
  data,
}: ISchoolTicketCreateParams): Promise<ISchoolTicketProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSchoolTicketByIdAsync = async (
  id: number,
): Promise<ISchoolTicketProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSchoolTicketByLicenseAsync = async (): Promise<
  ISchoolTicketSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSchoolTicketAsync = async ({
  id,
  data,
}: ISchoolTicketUpdateParams): Promise<ISchoolTicketProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSchoolTicketAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
